import React from "react";

/* eslint-disable max-len */
export default function GoodIcon() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
		<g>
			<path fill="none" stroke="#676767" strokeWidth="1.9405" strokeMiterlimit="10" d="M12,21.7l-1.5-1.4c-5.5-5-9.1-8.2-9.1-12.2
				c0-3.3,2.6-5.8,5.8-5.8c1.8,0,3.6,0.9,4.8,2.2c1.2-1.4,2.9-2.2,4.8-2.2c3.3,0,5.8,2.6,5.8,5.8c0,4-3.6,7.3-9.1,12.2L12,21.7z"/>
			<path fill="none" d="M0,0h24v24H0V0z"/>
		</g>
		</svg>
    );
}
